"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSwapXSession = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const AccountService_1 = require("../AccountService");
const AccountSession_1 = require("./AccountSession");
class BaseSwapXSession extends AccountSession_1.AccountSession {
    constructor(params, action) {
        super(params, action);
        this.verifyBiometric = (mfaParams) => {
            var _a, _b, _c;
            const faceId = this.findVerifyItemIgnoreCase(mfaParams, AccountSession_1.BiometricType.FaceId);
            const touchId = this.findVerifyItemIgnoreCase(mfaParams, AccountSession_1.BiometricType.TouchId);
            const passcode = this.findVerifyItemIgnoreCase(mfaParams, AccountSession_1.BiometricType.Passcode);
            const verifyTypes = [];
            let nonce = "";
            let type = "";
            if (faceId && faceId.items.length > 0) {
                verifyTypes.push(AccountSession_1.VerifyType.verify_FaceId);
                nonce = (_a = faceId.items[0].nonce) !== null && _a !== void 0 ? _a : "";
                type = AccountSession_1.BiometricType.FaceId;
            }
            else if (touchId && touchId.items.length > 0) {
                verifyTypes.push(AccountSession_1.VerifyType.verify_TouchId);
                nonce = (_b = touchId.items[0].nonce) !== null && _b !== void 0 ? _b : "";
                type = AccountSession_1.BiometricType.TouchId;
            }
            else if (passcode && passcode.items.length > 0) {
                verifyTypes.push(AccountSession_1.VerifyType.verify_Passcode);
                nonce = (_c = passcode.items[0].nonce) !== null && _c !== void 0 ? _c : "";
                type = AccountSession_1.BiometricType.Passcode;
            }
            if (verifyTypes.length === 0) {
                return (0, rxjs_1.of)({});
            }
            return new rxjs_1.Observable((subscriber) => {
                this.params.requestVerifyData({
                    action: this.action,
                    txn_id: mfaParams.txn_id,
                    verifyTypes: verifyTypes,
                    paramData: {
                        nonce: nonce,
                        type: type.toLowerCase(),
                    },
                    codeIds: {},
                    callback: (data) => {
                        var _a;
                        AccountService_1.AccountService.verifyBiometric({
                            txn_id: mfaParams.txn_id,
                            usage: this.action,
                            type: (_a = data["biometric_type"]) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                            signature: data["biometric_signature"],
                        }).subscribe({
                            next: (data) => {
                                subscriber.next(data);
                            },
                            error: (err) => {
                                subscriber.error(err);
                            },
                        });
                    },
                });
            });
        };
    }
    findVerifyItemIgnoreCase(mfaParams, verify_type) {
        return mfaParams.verify_items.find((item) => item.items.some((item) => item.verify_type.toLowerCase() === verify_type.toLowerCase()));
    }
    startSession(bizParams, device_info, requestExecutor) {
        this.subscription = AccountService_1.AccountService.generateMfaParams({
            usage: this.action,
            biz_params: bizParams,
            biometric_key: this.params.biometricKeyMd5,
            device_info,
        })
            .pipe((0, operators_1.mergeMap)((mfaParams) => {
            return (0, rxjs_1.of)({}).pipe((0, operators_1.mergeMap)(() => this.verifyBiometric(mfaParams)), (0, operators_1.mergeMap)(() => {
                return requestExecutor(mfaParams);
            }));
        }))
            .pipe((0, operators_1.map)((data) => data))
            .subscribe(this.params.onSuccess, this.params.onError);
    }
}
exports.BaseSwapXSession = BaseSwapXSession;
